import axios from "axios";
import * as actionType from "../../constants/orderActionType.js";

export const superAdminDashboard = () => {
    return () => {
        return axios({
            method: "get",
            url: `${actionType.environment_url}/super-admin-dashboard`,
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("shiporfly_super_admin_authtoken")}`,
            },
        })
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
    };
};
